import React from 'react';
import './XPBar.css';

// `levelProgress` is exactly the shape playerProgressService returns:
// { current, required, next }. Never recomputes the curve client-side —
// the server is the one source of truth for the level formula.
const XPBar = ({ levelProgress, compact = false }) => {
  const { current, required, next } = levelProgress;
  const pct = required > 0 ? Math.min(100, Math.round((current / required) * 100)) : 100;
  const remaining = Math.max(0, required - current);

  return (
    <div className={`z-xpbar ${compact ? 'z-xpbar--compact' : ''}`}>
      <div className="z-xpbar-track" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100} aria-label={`${current} of ${required} XP to level ${next}`}>
        <div className="z-xpbar-fill" style={{ width: `${pct}%` }} />
      </div>
      {!compact && (
        <div className="z-xpbar-caption">
          <span>{current.toLocaleString()} / {required.toLocaleString()} XP</span>
          <span className="z-xpbar-remaining">{remaining.toLocaleString()} XP to Lv {next}</span>
        </div>
      )}
    </div>
  );
};

export default XPBar;
